<template>
  <span class="kv-tag">
    <span class="kv-tag-label">{{ label }}</span>
    <span class="kv-tag-value">{{ value }}</span>
  </span>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
  value: string | number;
}>();
</script>

<style scoped>
.kv-tag {
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  font-size: 0.8rem;
  overflow: hidden;
  border: 1px solid var(--p-surface-200);
}

.kv-tag-label {
  padding: 3px 8px;
  background: var(--p-surface-100);
  color: var(--p-text-muted-color);
  font-weight: 600;
}

.kv-tag-value {
  padding: 3px 8px;
  color: var(--p-text-color);
}
</style>
